import React from "react";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import ActivityLogsTable from "./ActivityLogsTable";
import { getHistoryLogs } from "./ActivityLogsAPI";
import activityLogsHelp from "../../../content/help/activity-logs.json";

export default function ActivityLogs({ pageTitle = "Activity Logs" }) {
  usePageTitle("SkeyeGate Activity Logs - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    contextHolder,
    handleSearch,
    clearFilter,
  } = usePageState({
    fetchFn: getHistoryLogs,
    filterFields: ["username", "action", "target", "details", "clientIp"],
    defaultPageSize: 25,
  });

  return (
    <div className="activity-logs-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        helpContent={activityLogsHelp}
        description="View a comprehensive log of all activities, including user actions, system events, and changes across the platform."
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
          showAdd={false}
        />
        <ActivityLogsTable data={filteredData} loading={loading} />
      </PageLayout>
    </div>
  );
}
